import { MenuItem, TextField } from "@mui/material";
import useStore from "./useStore";
import { txt } from "../../../services/translation";

export default function Orientation(){

    const { orientation, resetItems, setOrientation} = useStore()

    const handleOrientationChange = e => {

        resetItems()

        setOrientation(e.target.value)
    }

    return (

        <TextField
            select 
            label={txt('orientation')}
            value={orientation}
            onChange={handleOrientationChange}
            required
            size='small'
            sx={{width: 150}}
        >
            <MenuItem value='L'>{txt('landscape')}</MenuItem>
            <MenuItem value='P'>{txt('portrait')}</MenuItem>
        </TextField>


    )
}